import React from 'react'
import {
  CBadge,
  CCard,
  CCardBody,
  CForm,
  CFormInput,
  CLoadingButton,
  CSpinner,
} from '@coreui/react-pro'
import CIcon from '@coreui/icons-react'
import { cilFlagAlt } from '@coreui/icons'
import { useFormik } from 'formik'
import CommonService from 'src/service/CommonService'
import ToastComponent from 'src/components/common/TaostComponent'
import { InfoBox } from 'src/components/common/ImportWizard'

const ResultBonus = ({ data, loading, loadingResultBonus, setLoadingResultBonus }) => {
  const formik = useFormik({
    initialValues: {
      data,
    },
    enableReinitialize: true,
    onSubmit: (values) => {
      setLoadingResultBonus(true)
      CommonService.updateBonusPoint({ data: values.data, type: 'result_bonus' })
        .then((res) => {
          if (res.status === 200) {
            ToastComponent(res.message, 'success')
          } else {
            ToastComponent(res.message, 'error')
          }
        })
        .catch(() => {
          ToastComponent('Something went wrong. Please try again.', 'error')
        })
        .finally(() => setLoadingResultBonus(false))
    },
  })

  return (
    <CCard className="bp-panel">
      <CCardBody>
        <div className="bp-panel-toolbar">
          <div>
            <h2 className="bp-panel-title">
              <CIcon icon={cilFlagAlt} className="me-2 text-info" />
              Match Winner Bonus
            </h2>
            <p className="bp-panel-note">
              Extra fantasy points awarded to every player on the winning team of a fixture.
            </p>
          </div>
        </div>

        <InfoBox color="info">
          Applies once a fixture&apos;s result is recorded. Leave a team&apos;s value unchanged to
          keep its current bonus.
        </InfoBox>

        {loading ? (
          <div className="d-flex align-items-center gap-2 text-medium-emphasis py-4">
            <CSpinner size="sm" />
            <span>Loading teams...</span>
          </div>
        ) : (
          <CForm onSubmit={formik.handleSubmit}>
            <div className="bp-table-wrap">
              <table className="bp-table">
                <thead>
                  <tr>
                    <th>Team</th>
                    <th className="bp-table-col-input text-end">Bonus Points</th>
                  </tr>
                </thead>
                <tbody>
                  {data.length === 0 ? (
                    <tr>
                      <td colSpan={2} className="text-center text-medium-emphasis py-4">
                        No teams yet - add a team before setting bonus points.
                      </td>
                    </tr>
                  ) : (
                    data.map((item, index) => (
                      <tr key={item.id}>
                        <td className="bp-team-name">{item.name}</td>
                        <td className="text-end">
                          <CFormInput
                            id={`match_bonus_${item.id}`}
                            className="bp-input ms-auto"
                            type="number"
                            step="any"
                            inputMode="decimal"
                            value={formik.values.data[index]?.match_bonus ?? ''}
                            onChange={(e) =>
                              formik.setFieldValue(`data.${index}.match_bonus`, e.target.value)
                            }
                            onFocus={(e) => e.target.select()}
                            onWheel={(e) => e.target.blur()}
                          />
                        </td>
                      </tr>
                    ))
                  )}
                </tbody>
              </table>
            </div>

            {data.length > 0 && (
              <div className="bp-form-actions">
                <CLoadingButton type="submit" color="primary" loading={loadingResultBonus}>
                  Save
                </CLoadingButton>
                {formik.dirty && (
                  <CBadge color="warning" shape="rounded-pill" className="px-3 py-2">
                    Unsaved changes
                  </CBadge>
                )}
              </div>
            )}
          </CForm>
        )}
      </CCardBody>
    </CCard>
  )
}

export default ResultBonus
